// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item_je+8d","active":"active_fsjM3","title":"title_-Hjde","content":"content_0hRaH"};